// import '@ant-design/compatible/assets/index.css';
// Removed Button import
import { API, Auth } from 'aws-amplify';
import QueryString from 'query-string';
// CBButton is already imported via cbd import below
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SEO from '../../../components/SEO';
import { ReactComponent as Logo } from '../../../images/svg/cb_log_2024_orange_white.svg';
import { useLocalization } from '../../../localization'; // Added import
import { useGlobalState } from '../../../store';
import {
  INVALID_CODE,
  INVALID_EMAIL,
  getAuthState,
  getUser,
  signinUser,
  signupUser,
  validateCode,
  validateEmail,
} from '../../../utils/auth';
import { getDocument, getProcessEnv, getWindow } from '../../../utils/browserGlobals';
import {
  CBButton,
  CBInput
} from '../../core/components/cbd';

export default function LoginPage({ location, isSignup = false }) {
  const { t } = useLocalization(); // Added hook call
  const [isLoading, setIsLoading] = useState(false);
  const [redirected, setRedirect] = useState(null);

  const [email, setEmail] = useState('');
  const [confirmationCode, setConfirmationCode] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [user, setUser] = useState(null);
  const [requested, setRequested] = useState(false);
  const [reactivate, setReactivate] = useState(false);
  const [, setGlobalUser] = useGlobalState('user');
  const navigate = useNavigate();

  useEffect(() => {
    async function onLoad() {
      let params = {};
      if (location && location.search) {
        params = QueryString.parse(location.search);
      }
      if (params.redirect) setRedirect(params.redirect);
      const authState = getAuthState();

      if (authState == 'signedIn') {
        if (params.redirect) {
          const win = getWindow();
          if (win) {
            win.location.href = win.location.origin + params.redirect;
          } else {
            window.location.href = '/dashboard';
          }
        } else {
          // Use window.location.href instead of navigate
          console.log('Using window.location.href to navigate to dashboard');
          window.location.href = '/dashboard';
        }

        return;
      }
      const tuser = getUser();

      setUser(tuser);
      //check for magic link params

      if (params.code) {
        //re-hyrdrate user and do answer
        setIsLoading(true);
        answerChallenge(params.code, tuser, params.redirect);
      }
      if (params.requested) {
        setRequested(true);
      }
    }

    onLoad();
  }, []);


  async function answerChallenge(answer, usr, redirect) {
    if (!usr) {
      setIsLoading(false);
      return;
    }

    usr.sendCustomChallengeAnswer(answer, {
      onSuccess(session) {
        setIsLoading(false);
        verifyAuthentication();
        const win = getWindow();
        if (win) {
          if (redirect) {
            win.location.href = win.location.origin + redirect;
          } else if (redirected) {
            win.location.href = win.location.origin + redirected;
          } else {
            window.location.href = '/dashboard';
          }
        } else {
          window.location.href = '/dashboard';
        }
      },
      onFailure(err) {
        console.error(err);
        setIsLoading(false);
      },
    });
  }

  async function verifyAuthentication(failureMessage = INVALID_CODE) {
    try {
      // This will throw an error if the user is not yet authenticated
      await Auth.currentSession();
      return true;
    } catch {
      // Use localized message if possible, otherwise fallback
      const localizedFailure = failureMessage === INVALID_CODE ? t('login.invalid_code') : failureMessage === INVALID_EMAIL ? t('login.invalid_email') : failureMessage;
      setErrorMessage(localizedFailure);
    }
    return false;
  }

  async function answerCustomChallenge(answer) {
    // Send the answer to the User Pool
    // This will throw an error if it’s the 3rd wrong answer
    var succeed = await Auth.sendCustomChallengeAnswer(user, answer);
    if (!succeed) {
      return false;
    }
    return verifyAuthentication();
  }

  async function reactivateThem(em) {
    //e.preventDefault()
    const email = (em ).toLowerCase();
    if (!validateEmail(email)) {
      setErrorMessage(t('login.invalid_email')); 
      return;
    }

    setIsLoading(true);
    setErrorMessage(null);

    try {
      const link = await API.post('bridge', '/links?reactivate=' + encodeURIComponent(email));
      setReactivate(false);
      requestLogin(email);
    } catch (e) {
        setErrorMessage(e.message); // Keep API errors as is for now
    }

    setIsLoading(false);
  }

  async function requestLogin(em) {
    //e.preventDefault()
    const email = (em || user.username).toLowerCase();
    if (!validateEmail(email)) {
      setErrorMessage(t('login.invalid_email')); 
      return;
    }

    setIsLoading(true);
    setErrorMessage(null);

    try {
      const user = await signinUser(email);
      setUser(user);
      setRequested(true);
      setReactivate(false);
      // setEmail('') if this shit fucks up
    } catch (e) {

      if (e.message.toLowerCase().includes('quota')) {
        setErrorMessage(t('login.quota_exceeded')); 
      } else if(e.message.includes('inactive')){
        var add = "";
        if(email.includes("hotmail") || email.includes("outlook")){
          add = t('login.inactive_hotmail_outlook_note'); 
        }
        setErrorMessage(t('login.inactive_email_error') + add); 
        setRequested(false);
        setReactivate(true);
      } else {
        setErrorMessage(e.message); // Keep other API errors as is
      }
    }

    setIsLoading(false);
  }

  async function requestSignup(e) {
    // e.preventDefault()
    const email = e.toLowerCase();

    if (!validateEmail(email)) {
      setErrorMessage(t('login.invalid_email')); 
      return;
    }

    await signupUser(email);
    requestLogin(email);
  }

  async function loginWithCode(e) {
    //e.preventDefault()
    if (!validateCode(e)) {
      setErrorMessage(t('login.invalid_code')); 
      return;
    }

    setIsLoading(true);
    setErrorMessage(null);

    try {
      const loggedIn = await answerCustomChallenge(e);
      if (loggedIn) {
        let loginOrSignup = isSignup ? 'signup' : 'login';
        if (location && location.search) {
          const params = QueryString.parse(location.search);
          if (params.fromCta) {
            loginOrSignup = 'signup';
          }
        }
        const credentials = await Auth.currentCredentials();

        // Explicitly set the authentication state in localStorage
        console.log('Setting authentication state in localStorage');
        localStorage.setItem('amplify-authenticator-authState', 'signedIn');

        // Get the current authenticated user and set it in the global state
        try {
          console.log('Getting current authenticated user to set in global state');
          const currentUser = await Auth.currentAuthenticatedUser();
          console.log('Setting authenticated user in global state:', currentUser);
          setGlobalUser(currentUser);

          // Log that we've set the user in global state
          console.log('User set in global state, ready for dashboard to load data');
        } catch (err) {
          console.error('Error getting authenticated user:', err);
        }

        const win = getWindow();
        const doc = getDocument();

        if (redirected && win) {
          win.location.href = win.location.origin + redirected;
        } else {
          //push data to GTM
          if (win) {
            win.dataLayer = win.dataLayer || [];
            win.dataLayer.push({
              event: 'dashboardEvent',
              category: 'acquisition',
              action: loginOrSignup,
              label: credentials.identityId,
              email: user.username,
            });
          }

          //submit form submission to hubspot
          let _body = {
            fields: [
              {
                objectTypeId: '0-1',
                name: 'email',
                value: user.username,
              },
            ],
            context: {
              hutk: doc ? doc.cookie.replace(
                /(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/,
                '$1'
              ) : '',
              pageUri: win ? win.location.href : '',
              pageName: doc ? doc.title : '',
            },
          };
          fetch(
            'https://api.hsforms.com/submissions/v3/integration/submit/7894218/77cbaa09-ea7e-4d46-902e-9fa0a2bd33de',
            {
              method: 'POST',
              body: JSON.stringify(_body),
              headers: { 'Content-type': 'application/json; charset=UTF-8' },
            }
          )
            .then((response) => response.json())
            .then((json) => {
              const debugUI = getProcessEnv('REACT_APP_DEBUG_UI');
              if (debugUI === 'true') console.log(json);
            })
            .catch((err) => {
              const debugUI = getProcessEnv('REACT_APP_DEBUG_UI');
              if (debugUI === 'true') console.log(err);
            });
          console.log("NAVIGATE using window.location.href");
          window.location.href = '/dashboard';
        }
      } else {
        setErrorMessage(t('login.invalid_code')); 
      }
    } catch (e) {
      setErrorMessage(e.message); // Keep API errors as is
    }
    setIsLoading(false);
  }

  function renderLoginForm() {
    const buttonText = isLoading
      ? t('common.loading')
      : isSignup
      ? t('signup.start_trial_button')
      : reactivate
      ? t('login.reactivate_button')
      : t('login.login_button');

    return (
      <>
        <div className="flex flex-col  p-4 border-2 border-neutral shadow-lg rounded-sm font-sarabun text-neutral_4 space-y-4">
          <div className="flex items-center justify-center mb-2">
            <a href="https://www.calendarbridge.com">
              <Logo height="50px"></Logo>
            </a>
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (isSignup) {
                requestSignup(email);
              } else {
                requestLogin(email);
              }
            }}
          >
            <CBInput
              id="email"
              hint={t('common.email_address')} 
              value={email}
              disabled={isLoading}
              onChange={(e) => setEmail(e.trim())}
              error={errorMessage}
            ></CBInput>
          </form>

          <div>
            <div className="flex items-center justify-center mb-2">
              <CBButton
                className="bg-blue_highlight text-white font-manrope font-bold py-3 px-8 rounded-md hover:bg-darkblue_highlight focus:outline-none focus:ring-2 focus:ring-blue_highlight focus:ring-opacity-50 uppercase"
                disabled={isLoading}
                loading={isLoading}
                onClick={(e) =>
                  isSignup ? requestSignup(email) : reactivate ? reactivateThem(email): requestLogin(email)
                }
              >
                {buttonText} {/* Localized */}
              </CBButton>
            </div>
          </div>
        </div>
        {isSignup && (
          <div className="mt-3 font-sarabun">
            {t('signup.accept_terms_prefix')}{' '} {/* Localized */}
            <a href="https://calendarbridge.com/terms-and-privacy" className="underline" target="_empty">{t('signup.terms_of_service')}</a> {/* Localized */}
            <div>
              {t('signup.already_have_account')}{' '} {/* Localized */}
              <Link className="underline"  to="/login">{t('signup.sign_in_link')}</Link> {/* Localized */}
            </div>
          </div>
        )}
        {!isSignup && (
          <div className="mt-3 font-sarabun">
            <div>
              {t('login.no_account')}{' '} {/* Localized */}
              <Link className="underline"  to="/signup">{t('login.sign_up_link')}</Link> {/* Localized */}
            </div>
          </div>
        )}
      </>
    );
  }
  function renderConfirmationForm() {
    return (
      <div id="confirm">
        <div className="flex flex-col  p-4 border-2 border-neutral rounded-sm font-sarabun text-neutral_4 space-y-4">
          <div className="flex items-center justify-center mb-2">
            <Logo height="50px"></Logo>
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              loginWithCode(confirmationCode);
            }}
          >
            <CBInput
              label={
                <div>
                  {t('login.code_sent_to')} <b>{user.username}</b> {/* Localized */}
                </div>
              }
              id="confirmationCode"
              hint={t('login.confirmation_code_hint')} 
              disabled={isLoading}
              value={confirmationCode}
              onChange={(e) => setConfirmationCode(e.trim())}
              error={errorMessage}
            ></CBInput>
          </form>

          <div>
            <div className="flex items-center justify-center mb-2">
              <CBButton
                loading={isLoading}
                disabled={isLoading}
                onClick={(e) => loginWithCode(confirmationCode)}
              >
                {t('login.verify_button')} {/* Localized */}
              </CBButton>
            </div>
            <div className="font-sarabun text-sm" style={{ lineHeight: '1.2em' }}> {/* Adjusted styling */}
              {t('login.did_not_get_email')}{' '} {/* Localized */}
              {/* Replaced Button with CBButton */}
              <CBButton type="link" onClick={(e) => requestLogin(email)} className="p-0 h-auto inline text-blue-600 hover:underline"> {/* Basic link styling */}
                {t('login.request_another_code')} {/* Localized */}
              </CBButton>
              <br />
              <b>{t('login.check_spam')}</b> {/* Localized */}
            </div>
          </div>
        </div>
      </div>
    );
  }

  const seoTitle = isSignup
    ? t('signup.seo_title')
    : t('login.seo_title');
  const seoDescription = isSignup
    ? t('signup.seo_description')
    : t('login.seo_description');

  return (
    <div
      style={{
        maxWidth: 450,
        margin: '50px auto',
        textAlign: 'center',
      }}
    >
      <SEO
        title={seoTitle} 
        description={seoDescription} 
      />
      {(user && requested) ? renderConfirmationForm() : renderLoginForm()}
      <div
        className="font-sarabun text-neutral_4"
        style={{ textAlign: 'center' }}
      >
        {t('common.copyright')} {/* Localized */}
      </div>
    </div>
  );
}
